import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";

const STATUS_STYLE = {
  Lead: "bg-slate-100 text-slate-700",
  Quoted: "bg-violet-50 text-violet-700",
  Booked: "bg-blue-50 text-blue-700",
  "In Progress": "bg-amber-50 text-amber-700",
  Delivered: "bg-emerald-50 text-emerald-700",
  "Follow-up": "bg-crimson-50 text-crimson-700",
  "Repeat/Referral": "bg-fuchsia-50 text-fuchsia-700",
};

export const StatusBadge = ({ status }) => (
  <Badge
    data-testid={`status-badge-${String(status).replace(/[\s/]/g, "-")}`}
    className={`border-0 ${STATUS_STYLE[status] || "bg-slate-100 text-slate-700"}`}
  >
    {status}
  </Badge>
);

export const LeadBadge = ({ source }) => (
  <Badge className="border border-brand-line bg-brand-tint text-brand" variant="outline">
    {source}
  </Badge>
);

export const PageHead = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
    <div className="flex items-stretch gap-3">
      <span aria-hidden className="mt-1 w-1.5 shrink-0 rounded-full bg-crimson-500" />
      <div>
        <h1 className="font-display text-3xl font-semibold text-brand-ink sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const EmptyState = ({ icon: Icon, title, hint, action, testid }) => (
  <div
    data-testid={testid}
    className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-brand-line bg-brand-tint/50 px-6 py-14 text-center"
  >
    {Icon && (
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand text-white shadow-[0_10px_24px_-12px_rgba(63,10,114,0.8)]">
        <Icon className="h-5 w-5" strokeWidth={1.8} />
      </span>
    )}
    <p className="font-display text-base font-semibold text-brand-ink md:text-lg">{title}</p>
    {hint && <p className="max-w-md text-sm text-muted-foreground">{hint}</p>}
    {action && <div className="mt-1">{action}</div>}
  </div>
);

export const Kpi = ({ label, value, hint, testid, accent, onClick }) => (
  <Card
    onClick={onClick}
    className={`overflow-hidden border-brand-line shadow-none transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_16px_36px_-24px_rgba(63,10,114,0.7)]${onClick ? " cursor-pointer" : ""}`}
    data-testid={onClick && testid ? `${testid}-card` : undefined}
  >
    <CardContent className="relative p-6">
      <span aria-hidden className="absolute inset-y-0 left-0 w-1 bg-crimson-500/80" />
      <p className="text-xs font-semibold uppercase tracking-wide text-brand/70">{label}</p>
      <p
        data-testid={testid}
        className={`font-display mt-2 text-3xl font-semibold ${accent || "text-brand-ink"}`}
      >
        {value}
      </p>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
      {onClick && <p className="mt-2 text-[11px] font-medium text-brand/70">View breakdown →</p>}
    </CardContent>
  </Card>
);
